import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import woman from './woman.jpg'
import styles from './about-1.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'Vad du fått med Dooer',
    id: 'consultant.section-two.heading',
  },
  textOneHeading: {
    defaultMessage: 'En personlig senior ekonom',
    id: 'consultant.section-two.text-one.heading',
  },
  textOneLede: {
    defaultMessage:
      'Som kund hos Dooer fick du omedelbart en dedikerad personlig senior ekonom till dig och ditt företag. Det känns otroligt skönt hur snabbt din ekonom lärt sig din verksamhet, och hur bra ni lärt känna varandra och fungerar som ett team. Du får löpande redovisning, rådgivning och insyn i precis allt som händer.',
    id: 'consultant.section-two.text-one.lede',
  },
  textTwoHeading: {
    defaultMessage: 'Support och kommunikation när du behöver',
    id: 'consultant.section-two.text-two.heading',
  },
  textTwoLede: {
    defaultMessage:
      'När du har några frågor kring din bokföring så finns ditt team aldrig längre bort än ett mail, telefonsamtal eller meddelande i appen. Att din seniora ekonom och hela rådgivningsteamet dessutom alla jobbar in-house här i Sverige och svarar inom 24 timmar är en enorm trygghet.',
    id: 'consultant.section-two.text-two.lede',
  },
})

const texts = [
  {
    heading: <FormattedHTMLMessage {...messages.textOneHeading} />,
    lede: <FormattedHTMLMessage {...messages.textOneLede} />,
  },
  {
    heading: <FormattedHTMLMessage {...messages.textTwoHeading} />,
    lede: <FormattedHTMLMessage {...messages.textTwoLede} />,
  },
]

export default function About1() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />

        <div className={styles.content}>
          <img alt="ekonom" src={woman} />
          <div className={styles.textWrapper}>
            {texts.map((text) => (
              <div className={styles.text} key={text.heading.props.id}>
                <h3>{text.heading}</h3>
                <p>{text.lede}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
